import { useQuery } from "react-query";
import {
  metricsQueries,
  useMetricsService,
} from "../../../../services/metricsService";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";

export function useCardReportAssetsHook() {
  const maetricsService = useMetricsService();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [showRegisterModal, setShowRegisterModal] = useState(false);

  const [MlineYearChart, setMLineYearChart] = useState();

  const {
    data: singleMetricsData,
    isLoading: isLoadingSingleMetrics,
    isRefetching: isRefetchingSingleMetrics,
    refetch: refetchSingleMetrics,
  } = useQuery(metricsQueries.GET_SINGLE_BY_CLIENT, () =>
    maetricsService.getSingleByClient({
      // TODO Colocar dinamico
      fkClientId: 1,
    })
  );

  const {
    data: generalMetricsData,
    isLoading: isLoadingMetrics,
    isRefetching: isRefetchingMetrics,
    refetch: refetchGeneralMetrics,
  } = useQuery(metricsQueries.GET_ASSETS_GENERAL_BY_CLIENT, () =>
    maetricsService.getAssetMetricsGeneralById({
      // TODO Colocar dinamico
      fkClientId: 1,
    })
  );

  const {
    data: renovationMetricsData,
    isLoading: isLoadingRenovationMetrics,
    isRefetching: isRefetchingRenovationMetrics,
    refetch: refetchRenovationMetrics,
  } = useQuery(metricsQueries.GET_ASSETS_RENOVATION_BY_CLIENT, () =>
    maetricsService.getAssetsMetricsRenovationById({
      // TODO Colocar dinamico
      fkClientId: 1,
    })
  );

  const {
    data: dueDegradationsMetricsData,
    isLoading: isLoadingDueDegradationsMetrics,
    isRefetching: isRefetchingDueDegradationsMetrics,
    refetch: refetchDueDegradationsMetrics,
  } = useQuery(metricsQueries.GET_ASSETS_DUE_DEGRADATION_BY_CLIENT, () =>
    maetricsService.getAssetsMetricsDueDegradationById({
      // TODO Colocar dinamico
      fkClientId: 1,
    })
  );

  const {
    data: defectMetricsData,
    isLoading: isLoadingDefectMetrics,
    isRefetching: isRefetchingDefectMetrics,
    refetch: refetchDefectMetrics,
  } = useQuery(metricsQueries.GET_ASSETS_DEFECT_TYPES_BY_CLIENT, () =>
    maetricsService.getAssetsMetricsDefectTypesById({
      // TODO Colocar dinamico
      fkClientId: 1,
    })
  );

  const {
    data: maturityMetricsData,
    isLoading: isLoadingMaturityMetrics,
    isRefetching: isRefetchingmatirityMetrics,
    refetch: refetchMaturityMetrics,
  } = useQuery(metricsQueries.GET_ASSETS_MATURITY_BY_CLIENT, () =>
    maetricsService.getAssetsMetricsMaturityById({
      // TODO Colocar dinamico
      fkClientId: 1,
    })
  );

  function getChartdata(assetData) {
    const categories =
      assetData?.dueYears?.slice(0, 4)?.map((item) => item.labelYear) || [];
    const dataValues =
      assetData?.dueYears
        ?.slice(0, 4)
        ?.map((item) => parseFloat(item.totalArea[0] / 100).toFixed(2)) || [];
    const maxValue = Math.max(...dataValues);
    const minValue = Math.min(...dataValues);

    const data = {
      categories,
      series: [
        {
          color: "#ff0000",
          data: dataValues,
        },
      ],
      maxValue,
      minValue,
    };
    return data;
  }

  useEffect(() => {
    const categories =
      maturityMetricsData?.lineYearData?.map((item) => item.label) || [];
    const dataValues =
      maturityMetricsData?.lineYearData?.map((item) =>
        parseFloat(item.values[1] / 100).toFixed(2)
      ) || [];

    const totalDataValues = [];
    maturityMetricsData?.lineYearData?.forEach((item) => {
      totalDataValues.push(parseFloat(item.values[1] / 100).toFixed(2));
    });

    const maxValue = Math.max(...totalDataValues);
    const minValue = Math.min(...totalDataValues);

    setMLineYearChart({
      categories,
      series: [
        {
          name: "Passivo (m²)",
          color: "#ff4c00",
          data: dataValues,
        },
      ],
      maxValue,
      minValue,
    });
  }, [maturityMetricsData]);

  return {
    single: {
      metricsData: singleMetricsData,
      isLoading: isLoadingSingleMetrics || isRefetchingSingleMetrics,
      refetchSingleMetrics,
    },

    assets: {
      metricsData: generalMetricsData,
      isLoading: isLoadingMetrics || isRefetchingMetrics,
      refetchGeneralMetrics,
      getChartdata,
    },
    renovations: {
      metricsData: renovationMetricsData,
      isLoading: isLoadingRenovationMetrics || isRefetchingRenovationMetrics,
      refetchRenovationMetrics,
    },
    dueDegradations: {
      metricsData: dueDegradationsMetricsData,
      isLoading:
        isLoadingDueDegradationsMetrics || isRefetchingDueDegradationsMetrics,
      refetchDueDegradationsMetrics,
    },
    maturity: {
      MlineYearChart,
      metricsData: maturityMetricsData,
      isLoading: isLoadingMaturityMetrics || isRefetchingmatirityMetrics,
      refetchMaturityMetrics,
    },

    defectTypes: {
      metricsData: defectMetricsData,
      isLoading: isLoadingDefectMetrics || isRefetchingDefectMetrics,
      refetchDefectMetrics,
    },
    general: {
      showRegisterModal,
      setShowRegisterModal,
    },
    navigate,
    dispatch,
  };
}
